import { render, staticRenderFns } from "./pageHeaderCard.vue?vue&type=template&id=6c384010&scoped=true&"
import script from "./pageHeaderCard.vue?vue&type=script&lang=js&"
export * from "./pageHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./pageHeaderCard.vue?vue&type=style&index=0&id=6c384010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c384010",
  null
  
)

export default component.exports